import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { PillRow } from './PillRow';
import { usePlatform } from '../contexts/PlatformContext';
import { pregnancyPlans } from '../data/pregnancyPlans';
import { pills } from '../data/pills';
import { getFlaggedIds, formatAED } from '../utils/pack';
export function PregnancyPlanPicker() {
  const {
    stage,
    selectedPlanId,
    selectPlan,
    panel
  } = usePlatform();
  const selected = pregnancyPlans.find(p => p.id === selectedPlanId) ?? pregnancyPlans[0];
  const flagged = getFlaggedIds(panel);
  const nameOf = (id: string) => panel.find(b => b.id === id)?.name ?? id;
  return <div className="space-y-10" data-id="element-105" data-mp="317t2qhu2vmx">
      <div role="radiogroup" aria-label="Pregnancy plans" className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3" data-id="element-106" data-mp="2zdhw3wd6hw1">
        {pregnancyPlans.map(plan => {
        const isSelected = plan.id === selectedPlanId;
        const isRecommended = plan.id === stage;
        return <button key={plan.id} role="radio" aria-checked={isSelected} onClick={() => selectPlan(plan.id)} className={`relative rounded-2xl border p-5 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9b8cf0] ${isSelected ? 'border-[#9b8cf0] bg-[#9b8cf0]/[0.08]' : 'border-white/10 bg-white/[0.02] hover:border-white/20'}`} data-id="element-107" data-mp="1zw2v6l817f9a">
              <div className="flex items-center justify-between" data-id="element-108" data-mp="2kezw3dq72dj2">
                <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground" data-id="element-109" data-mp="2pdb55m8o0k08">{plan.window}</span>
                {isSelected && <span className="flex size-5 items-center justify-center rounded-full bg-[#9b8cf0] text-[#0f1017]" data-id="element-110" data-mp="2yf29onrgyksi">
                    <Check className="size-3" data-id="element-111" data-mp="z2gbe5ohri51" />
                  </span>}
              </div>
              <p className="mt-3 font-medium" data-id="element-112" data-mp="14081qv9hmw74">{plan.name}</p>
              <p className="mt-1 text-sm text-muted-foreground" data-id="element-113" data-mp="142uk7pxx2w44">{plan.focus}</p>
              <div className="mt-4 flex items-center justify-between" data-id="element-114" data-mp="27c73o78svt5p">
                <span className="font-mono text-xs" data-id="element-115" data-mp="22dvrvqyy38ku">{formatAED(plan.price)} / mo</span>
                {isRecommended && <span className="flex items-center gap-1 text-[11px] text-[#c4baff]" data-id="element-116" data-mp="2gdwsd5basdzs">
                    <Sparkles className="size-3" data-id="element-117" data-mp="2bbz2vtcb0mye" /> Recommended
                  </span>}
              </div>
            </button>;
      })}
      </div>

      <section aria-labelledby="inside-heading" data-id="element-118" data-mp="2lchr10awipm4">
        <h2 id="inside-heading" className="text-lg font-medium" data-id="element-119" data-mp="2l9vnrcv1mw9p">
          Inside your {selected.name} pack
        </h2>
        <p className="mt-1 text-sm text-muted-foreground" data-id="element-120" data-mp="2v1rnescs2ug1">
          Pre-portioned into morning and evening sachets. Tags show which of your results each one supports.
        </p>
        <ul className="mt-5 space-y-2" data-id="element-121" data-mp="38yy2abuds8zz">
          {selected.pillIds.map(id => {
          const pill = pills.find(p => p.id === id);
          if (!pill) return null;
          const reasons = pill.targets.filter(t => flagged.includes(t)).map(nameOf);
          return <PillRow key={id} pill={pill} reasons={reasons} data-id="element-122" data-mp="3smkjyq9n7g7v" />;
        })}
        </ul>
      </section>
    </div>;
}